import React from 'react';
import { Card, Label } from 'semantic-ui-react';
import ExpertInformation from './ExpertInformation';
import JobInformation from './JobInformation';
import JobActions from './JobActions';
import ManageJobButton from './ManageJobButton';
import SearchHighlights from './SearchHighlights';
import { getJobStatusColor } from '../../../../utils/jobStatus';

const JobCard = ({ job, searchResult = null }) => (
  <Card className={`request ${searchResult && 'search-result'}`}>
    <Card.Content>
      <ManageJobButton job={job} />
      <div className="status">
        <Label circular size="mini" color={getJobStatusColor(job.status)} empty />
        {` ${job.status}`}
      </div>
      <ExpertInformation job={job} />
      <Card.Description>
        <JobInformation job={job} />
      </Card.Description>
    </Card.Content>
    <Card.Content extra>
      {searchResult ? (
        <SearchHighlights searchResult={searchResult} />
      ) : (
        <JobActions job={job} />
      )}
    </Card.Content>
  </Card>
);

export default JobCard;
